import { combineReducers } from 'redux'

import sub from '@pagesComponents/subscription/reducer'

export default combineReducers ({
    sub
})